import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { clearCurrentRequest, fetchRequestDetailed, lockRequest } from "../../../../reducers/administration/requestSlice";
import { AppDispatch } from "../../../../store";
import { useParams } from "react-router-dom";
import { RequestDetailed } from "../../../../types/brm/request-types";

const RequestWrapper = ({ children }) => {
    const dispatch = useDispatch<AppDispatch>();
    const { requestId } = useParams();

    useEffect(() => {
        const fetchData = async () => {
            if (requestId) {
                const result = await dispatch(fetchRequestDetailed({ requestId }));
                if (fetchRequestDetailed.fulfilled.match(result)) {
                    const data = result.payload as RequestDetailed;
                
                    if (!data.readMode) {
                        dispatch(lockRequest(requestId));
                    }
                }
                
            }
        };

        fetchData();

        return () => {
            dispatch(clearCurrentRequest());
        };
    }, [dispatch, requestId]);

    return children;
};

export default RequestWrapper;
